import Goals from '@/view/components/Goals'
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from '@/view/components/ui/card'
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from '../../../../components/ui/avatar'
import { stringToColour } from '@/app/utils/changeBackgroundColorOfInitials'
import { getNameInitial } from '@/app/utils/getNameInitial'
import { formatMoneyValue } from '@/app/utils/formatMoneyValue'
import { UserRole } from '@/app/entities/UserRole'
import { formatName } from '@/app/utils/formatName'
import { useNavigate } from 'react-router-dom'

export const ManagersCard = ({
  _id,
  name,
  profileImageUrl,
  subordinates,
  members,
  membersTotal,
  transactions,
}: UserRole) => {
  const navigate = useNavigate()

  const handleCardClick = () => {
    navigate(`/gerentes/${_id || 'null'}`, {
      state: { managerName: name || '' },
    })
  }

  const isManagerNull = !_id

  const filteredSubordinates = subordinates.filter(
    (subordinate) => subordinate._id !== null,
  )

  return (
    <Card
      className="group relative flex min-h-[580px] cursor-pointer flex-col"
      onClick={handleCardClick}
    >
      <CardHeader className="grow">
        {isManagerNull ? (
          <>
            <div className="mb-7 mt-2 flex items-center justify-between">
              <p className="text-lg font-semibold">Sem gerente</p>
            </div>
            <div className="space-y-4">
              <div className="w-full border-[1px] border-white02" />
              <div className="flex items-center justify-center gap-4">
                <div className="flex h-20 w-full flex-col items-center justify-center rounded-lg border-[1px] border-gray02 bg-white px-3 py-2">
                  <p className="font-semibold">{transactions.count}</p>
                  <p className="text-xs font-medium text-black04">
                    Saques realizados
                  </p>
                </div>
                <div className="flex h-20 w-full flex-col items-center justify-center rounded-lg border-[1px] border-gray02 bg-white px-3 py-2">
                  <p className="font-semibold">
                    {formatMoneyValue(transactions.total)}
                  </p>
                  <p className="text-xs font-medium text-black04">
                    Valor Movimentado
                  </p>
                </div>
              </div>
              <p className="font-semibold">
                {filteredSubordinates.length}{' '}
                {filteredSubordinates.length === 1
                  ? 'Supervisor'
                  : 'Supervisores'}
              </p>
            </div>
          </>
        ) : (
          <>
            <div className="mb-4 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <Avatar className="h-12 w-12">
                  <AvatarImage
                    src={
                      profileImageUrl
                        ? `${import.meta.env.VITE_CDN_URL}${profileImageUrl}`
                        : undefined
                    }
                  />
                  <AvatarFallback
                    className="text-lg"
                    style={{
                      backgroundColor: stringToColour(name || ''),
                    }}
                  >
                    {getNameInitial(name || '')}
                  </AvatarFallback>
                </Avatar>
                <p className="text-lg font-semibold">
                  {name ? formatName(name) : ''}
                </p>
              </div>
              <div className="flex items-center gap-2">
                <div className="h-fit w-fit rounded-3xl bg-[#E3F9EC] px-2 py-1">
                  <p className="text-md font-semibold text-[#288F63]">
                    Gerente
                  </p>
                </div>
              </div>
            </div>
            <div className="space-y-4">
              <div className="w-full border-[1px] border-white02" />
              <div className="flex items-center justify-center gap-4">
                <div className="flex h-20 w-full flex-col items-center justify-center rounded-lg border-[1px] border-gray02 bg-white px-3 py-2">
                  <p className="font-semibold">{transactions.count}</p>
                  <p className="text-xs font-medium text-black04">
                    Saques realizados
                  </p>
                </div>
                <div className="flex h-20 w-full flex-col items-center justify-center rounded-lg border-[1px] border-gray02 bg-white px-3 py-2">
                  <p className="font-semibold">
                    {formatMoneyValue(transactions.total)}
                  </p>
                  <p className="text-xs font-medium text-black04">
                    Valor Movimentado
                  </p>
                </div>
              </div>
              <p className="font-semibold">
                {filteredSubordinates.length}{' '}
                {filteredSubordinates.length === 1
                  ? 'Supervisor'
                  : 'Supervisores'}
              </p>
            </div>
          </>
        )}
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-4">
          <Goals
            currentValue={transactions.total}
            subordinates={subordinates.slice(0, 2).map((subordinate) => ({
              name: subordinate.name || 'Produção Supervisores',
              total: subordinate.transactions.total,
            }))}
            variant="subordinate"
          />
        </div>
        <div className="w-full border-[1px] border-white02" />
      </CardContent>
      <CardFooter className="flex flex-col items-start">
        <p className="font-semibold">
          {membersTotal} {membersTotal === 1 ? 'membro' : 'membros'}
        </p>
        <div className="mt-4 flex flex-wrap">
          {members.length > 0 ? (
            <>
              {members.slice(0, 10).map((member, index) => (
                <Avatar
                  key={member._id}
                  className="h-8 w-8 border-2 border-white"
                  style={{ marginLeft: index > 0 ? '-6px' : '0' }}
                >
                  <AvatarImage src={member.profileImageUrl || ''} />
                  <AvatarFallback
                    style={{ backgroundColor: stringToColour(member.name) }}
                  >
                    {getNameInitial(member.name)}
                  </AvatarFallback>
                </Avatar>
              ))}
              {members.length > 10 && (
                <div className="ml-2 text-sm font-semibold">
                  +{members.length - 10}
                </div>
              )}
            </>
          ) : (
            <div className="p-4 text-sm text-black04">
              <p />
            </div>
          )}
        </div>
      </CardFooter>
    </Card>
  )
}
